<template>
  <div class="live-like" ref="liveLike"></div>
</template>
<script>
import BubbleHearts from 'bubble-hearts'
export default {
  name: 'LikeAnimation',
  data() {
    return {
      image: null,
      bubbleHearts: null
    }
  },
  methods: {
    add() {
      this.bubbleHearts.bubble(this.image, 3000)
    }
  },
  mounted() {
    this.bubbleHearts = new BubbleHearts()
    let canvas = this.bubbleHearts.canvas
    canvas.width = 90
    canvas.height = 300
    this.$refs.liveLike.appendChild(canvas)

    this.image = new Image()
    this.image.src = 'https://img.zai-art.com/web/prod/webapp/static/img/like_flower.png'
  }
}
</script>
<style>
.live-like {
  position: relative;
  width: 90px;
  height: 300px;
}
.live-like canvas {
  width: 100%;
  height: 100%;
}
</style>
